unit DashboardItemFactory;

{
  Dashboard widget factory.
  To add a type: add a preset in TDashboardItemLayout.ForType and register the string here.
}

interface

uses
  System.Classes,
  BaseDashboardItem;

type
  TDashboardItemFactory = class
  public
    class function IsKnownType(const ADashboardItemType: string): Boolean;
    class function CreateInstance(const ADashboardItemType: string;
      AOwner: TComponent): TBaseDashboardItem;
  end;

implementation

uses
  DashboardItemLayout,
  DashboardItemWidget;

class function TDashboardItemFactory.IsKnownType(const ADashboardItemType: string): Boolean;
begin
  Result := TDashboardItemLayout.IsKnownType(ADashboardItemType);
end;

class function TDashboardItemFactory.CreateInstance(const ADashboardItemType: string;
  AOwner: TComponent): TBaseDashboardItem;
var
  lWidget: TDashboardItemWidget;
begin
  Result := nil;
  if not TDashboardItemLayout.IsKnownType(ADashboardItemType) then
    Exit;

  lWidget := TDashboardItemWidget.Create(AOwner);
  lWidget.ApplyLayout(TDashboardItemLayout.ForType(ADashboardItemType));
  Result := lWidget;
end;

end.
